import * as React from "react";
import classNames from "classnames";

interface IProps {
	wrapperClassName?: string;
	sectionClassName?: string;
	children?: {};
	fluid?: boolean;
}

const SectionMain: React.FC<IProps> = ({
	fluid = false,
	wrapperClassName,
	sectionClassName,
	children,
}) => {
	return (
		<div
			className={classNames(
				fluid ? "container-fluid" : "container",
				wrapperClassName
			)}
		>
			<section className={classNames("section section-main", sectionClassName)}>
				{children}
			</section>
		</div>
	);
};

export default SectionMain;
